import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Navigate, Link } from '@tanstack/react-router'
import { ArrowLeftIcon } from 'lucide-react'

import { ApiError } from '@/api/errors'
import { portalApi } from '@/api/portal'
import { FormError } from '@/components/field-error'
import { Skeleton } from '@/components/ui/skeleton'
import { msg } from '@/i18n'

/**
 * Une section du cahier désignée par son id (lot 28 : la cloche vise la
 * section exacte) : on la lit, puis on ouvre sa page dans le cahier.
 */
export const Route = createFileRoute('/portal/sections/$sectionId')({
  component: SectionById,
})

function SectionById() {
  const { sectionId } = Route.useParams()
  const section = useQuery({
    queryKey: ['portal', 'spec-section', sectionId],
    queryFn: () => portalApi.specSection(sectionId),
  })
  if (section.isPending) return <Skeleton className="h-40 w-full rounded-lg" />
  if (section.isError) {
    return (
      <div className="space-y-3">
        <FormError>
          {section.error instanceof ApiError
            ? section.error.message
            : msg().portalSpec.section.gone}
        </FormError>
        {/* #401 : une page sans issue renvoie aux projets. */}
        <Link
          to="/portal/projets"
          className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
        >
          <ArrowLeftIcon className="size-3.5" aria-hidden="true" />
          {msg().common.backToProjects}
        </Link>
      </div>
    )
  }
  return (
    <Navigate
      to="/portal/projets/$projectId/cahier/$key"
      params={{ projectId: section.data.project.id, key: section.data.key }}
      replace
    />
  )
}
